var t = {
  lastWeek: "'上個'eeee p",
  yesterday: "'昨天' p",
  today: "'今天' p",
  tomorrow: "'明天' p",
  nextWeek: "'下個'eeee p",
  other: "P"
};
function p(e, a, o, r) {
  return t[e];
}
export {
  p as default
};
//# sourceMappingURL=index195.mjs.map
